import {
  TENANT_DETAILS_REQUEST,
  TENANT_DETAILS_SUCCESS,
  TENANT_DETAILS_FAIL,
  TENANT_DETAILS_RESET,
  TENANT_UPDATE_CLINICNAME_REQUEST,
  TENANT_UPDATE_CLINICNAME_SUCCESS,
  TENANT_UPDATE_CLINICNAME_FAIL,
  TENANT_UPDATE_CLINICNAME_RESET,
  TENANT_UPDATE_SUPPORTEMAIL_REQUEST,
  TENANT_UPDATE_SUPPORTEMAIL_SUCCESS,
  TENANT_UPDATE_SUPPORTEMAIL_FAIL,
  TENANT_UPDATE_SUPPORTEMAIL_RESET,
  TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST,
  TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS,
  TENANT_UPDATE_OPERATINGCOUNTRY_FAIL,
  TENANT_UPDATE_OPERATINGCOUNTRY_RESET,
  TENANT_UPDATE_ONBOARDING_STATUS_REQUEST,
  TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS,
  TENANT_UPDATE_ONBOARDING_STATUS_FAIL,
  TENANT_UPDATE_ONBOARDING_STATUS_RESET,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL,
  TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_RESET,
  TENANT_UPDATE_LOGO_REQUEST,
  TENANT_UPDATE_LOGO_SUCCESS,
  TENANT_UPDATE_LOGO_FAIL,
  TENANT_UPDATE_LOGO_RESET,
  TENANT_UPDATE_CLINIC_DETAILS_REQUEST,
  TENANT_UPDATE_CLINIC_DETAILS_SUCCESS,
  TENANT_UPDATE_CLINIC_DETAILS_FAIL,
  TENANT_UPDATE_CLINIC_DETAILS_RESET,
  TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST,
  TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS,
  TENANT_UPDATE_REGIONAL_SETTINGS_FAIL,
  TENANT_UPDATE_REGIONAL_SETTINGS_RESET,
  TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST,
  TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS,
  TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL,
  TENANT_UPDATE_SCHEDULING_SETTINGS_RESET,
  TENANT_UPDATE_DENTAL_CHAIRS_REQUEST,
  TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS,
  TENANT_UPDATE_DENTAL_CHAIRS_FAIL,
  TENANT_UPDATE_DENTAL_CHAIRS_RESET,
  TENANT_UPDATE_COMPANY_DETAILS_REQUEST,
  TENANT_UPDATE_COMPANY_DETAILS_SUCCESS,
  TENANT_UPDATE_COMPANY_DETAILS_FAIL,
  TENANT_UPDATE_COMPANY_DETAILS_RESET,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL,
  TENANT_UPDATE_SUBSCRIPTION_STATUS_RESET,
  TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST,
  TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS,
  TENANT_GET_SUBSCRIPTION_LIMITS_FAIL,
  TENANT_GET_SUBSCRIPTION_LIMITS_RESET,
  TENANT_GET_STRIPE_INVOICES_REQUEST,
  TENANT_GET_STRIPE_INVOICES_SUCCESS,
  TENANT_GET_STRIPE_INVOICES_FAIL,
  TENANT_GET_STRIPE_INVOICES_RESET,
  TENANT_GET_PUBLIC_DETAILS_REQUEST,
  TENANT_GET_PUBLIC_DETAILS_SUCCESS,
  TENANT_GET_PUBLIC_DETAILS_FAIL,
  TENANT_GET_PUBLIC_DETAILS_RESET,
  TENANT_DETAILS_BY_SLUG_REQUEST,
  TENANT_DETAILS_BY_SLUG_SUCCESS,
  TENANT_DETAILS_BY_SLUG_FAIL,
  TENANT_DETAILS_BY_SLUG_RESET,
  TENANT_INVITE_USER_REQUEST,
  TENANT_INVITE_USER_SUCCESS,
  TENANT_INVITE_USER_FAIL,
  TENANT_INVITE_USER_RESET,
  TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST,
  TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS,
  TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL,
  TENANT_UPDATE_DEFAULT_COORDINATOR_RESET,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL,
  TENANT_UPDATE_TENANT_USER_PERMISSIONS_RESET,
  TENANT_DELETE_ACCOUNT_REQUEST,
  TENANT_DELETE_ACCOUNT_SUCCESS,
  TENANT_DELETE_ACCOUNT_FAIL,
  TENANT_DELETE_ACCOUNT_RESET,
} from "../constants/tenantConstants";

export const tenantDetailsReducer = (state = { tenant: null }, action) => {
  switch (action.type) {
    case TENANT_DETAILS_REQUEST:
      return { ...state, loading: true };
    case TENANT_DETAILS_SUCCESS:
      return { loading: false, success: true, tenant: action.payload };
    case TENANT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_DETAILS_RESET:
      return { tenant: {} };
    default:
      return state;
  }
};

export const tenantDetailsBySlugReducer = (
  state = { tenant: null },
  action
) => {
  switch (action.type) {
    case TENANT_DETAILS_BY_SLUG_REQUEST:
      return { ...state, loading: true };
    case TENANT_DETAILS_BY_SLUG_SUCCESS:
      return { loading: false, success: true, tenant: action.payload };
    case TENANT_DETAILS_BY_SLUG_FAIL:
      return { loading: false, error: action.payload };

    case TENANT_DETAILS_BY_SLUG_RESET:
      return { tenant: {} };
    default:
      return state;
  }
};

export const tenantUpdateClinicNameReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_CLINICNAME_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_CLINICNAME_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_CLINICNAME_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_CLINICNAME_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateSupportEmailReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_SUPPORTEMAIL_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_SUPPORTEMAIL_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_SUPPORTEMAIL_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_SUPPORTEMAIL_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateOperatingCountryReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_OPERATINGCOUNTRY_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_OPERATINGCOUNTRY_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_OPERATINGCOUNTRY_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_OPERATINGCOUNTRY_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateOnboardingStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_ONBOARDING_STATUS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_ONBOARDING_STATUS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_ONBOARDING_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_ONBOARDING_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantSeedDatabaseUpdateOnboardingStatusReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_REQUEST:
      return { loading: true };
    case TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_SUCCESS:
      return { loading: false, success: true, slug: action.payload.slug };
    case TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_SEED_DATABASE_UPDATE_ONBOARDING_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_LOGO_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_LOGO_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_LOGO_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_LOGO_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateClinicDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_CLINIC_DETAILS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_CLINIC_DETAILS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_CLINIC_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_CLINIC_DETAILS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateRegionalSettingsReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_REGIONAL_SETTINGS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_REGIONAL_SETTINGS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_REGIONAL_SETTINGS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_REGIONAL_SETTINGS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateSchedulingSettingsReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_SCHEDULING_SETTINGS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_SCHEDULING_SETTINGS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_SCHEDULING_SETTINGS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_SCHEDULING_SETTINGS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateDentalChairsReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_DENTAL_CHAIRS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_DENTAL_CHAIRS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_DENTAL_CHAIRS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_DENTAL_CHAIRS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateCompanyDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_COMPANY_DETAILS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_COMPANY_DETAILS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_COMPANY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_COMPANY_DETAILS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateSubscriptionStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_SUBSCRIPTION_STATUS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_SUBSCRIPTION_STATUS_SUCCESS:
      return { loading: false, success: true };
    case TENANT_UPDATE_SUBSCRIPTION_STATUS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_SUBSCRIPTION_STATUS_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantGetSubscriptionUsageReducer = (
  state = { limits: {} },
  action
) => {
  switch (action.type) {
    case TENANT_GET_SUBSCRIPTION_LIMITS_REQUEST:
      return { ...state, loading: true };

    case TENANT_GET_SUBSCRIPTION_LIMITS_SUCCESS:
      return {
        ...state,
        loading: false,
        limits: {
          ...state.limits, // ✅ Keep previously fetched limits
          [action.payload.moduleName]: {
            // ✅ Store limits by module name
            usageCount: action.payload.usageCount,
            plan: action.payload.plan,
            limitCount: action.payload.limitCount,
            nextBillingDate: action.payload.nextBillingDate,
          },
        },
      };
    case TENANT_GET_SUBSCRIPTION_LIMITS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case TENANT_GET_SUBSCRIPTION_LIMITS_RESET:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const tenantGetStripeInvoicesReducer = (
  state = { invoices: [], page: 1, totalInvoices: 0, pages: 1 },
  action
) => {
  switch (action.type) {
    case TENANT_GET_STRIPE_INVOICES_REQUEST:
      return { ...state, loading: true };

    case TENANT_GET_STRIPE_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        invoices:
          action.payload.page === 1
            ? action.payload.invoices
            : [...state.invoices, ...action.payload.invoices],
        nextCursor: action.payload.nextCursor,
        totalInvoices: action.payload.totalInvoices,
        page: action.payload.page,
        pages: action.payload.pages,
      };

    case TENANT_GET_STRIPE_INVOICES_FAIL:
      return { ...state, loading: false, error: action.payload };

    case TENANT_GET_STRIPE_INVOICES_RESET:
      return { invoices: [], page: 1, totalInvoices: 0, pages: 1 };

    default:
      return state;
  }
};

export const tenantGetPublicDetailsReducer = (
  state = { tenantPublic: null },
  action
) => {
  switch (action.type) {
    case TENANT_GET_PUBLIC_DETAILS_REQUEST:
      return { ...state, loading: true };
    case TENANT_GET_PUBLIC_DETAILS_SUCCESS:
      return { loading: false, success: true, tenantPublic: action.payload };
    case TENANT_GET_PUBLIC_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_GET_PUBLIC_DETAILS_RESET:
      return { tenantPublic: {} };
    default:
      return state;
  }
};

export const tenantInviteUserToTenantReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_INVITE_USER_REQUEST:
      return { loading: true };
    case TENANT_INVITE_USER_SUCCESS:
      return { loading: false, success: true, message: action.payload.message };
    case TENANT_INVITE_USER_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_INVITE_USER_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateDefaultCoordinatorReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_UPDATE_DEFAULT_COORDINATOR_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_DEFAULT_COORDINATOR_SUCCESS:
      return {
        loading: false,
        success: true,
        defaultTreatmentPlanEmployee:
          action.payload.defaultTreatmentPlanEmployee,
      };
    case TENANT_UPDATE_DEFAULT_COORDINATOR_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_DEFAULT_COORDINATOR_RESET:
      return {};
    default:
      return state;
  }
};

export const tenantUpdateTenantUserPermissionsReducer = (
  state = {
    forceLogout: false, // Default to false
  },
  action
) => {
  switch (action.type) {
    case TENANT_UPDATE_TENANT_USER_PERMISSIONS_REQUEST:
      return { loading: true };
    case TENANT_UPDATE_TENANT_USER_PERMISSIONS_SUCCESS:
      return {
        loading: false,
        success: true,
        forceLogout: action.payload.forceLogout,
      };
    case TENANT_UPDATE_TENANT_USER_PERMISSIONS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_UPDATE_TENANT_USER_PERMISSIONS_RESET:
      return {
        forceLogout: false, // Reset to default
      };
    default:
      return state;
  }
};

export const tenantDeleteAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_DELETE_ACCOUNT_REQUEST:
      return { loading: true };
    case TENANT_DELETE_ACCOUNT_SUCCESS:
      return { loading: false, success: true };
    case TENANT_DELETE_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_DELETE_ACCOUNT_RESET:
      return {};
    default:
      return state;
  }
};
